import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../Common/Configurations/APIConfig';

const RegisterCustomer = () => {
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    
    const [values, setValues] = useState({
        fullName: '',
        email: '',
        phone: '',
        address: '',
        password: '',
    });

    const [errors, setErrors] = useState({});

    const handleInput = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let temp = {};
        temp.fullName = values.fullName ? "" : "Full Name is required";
        temp.email = (/$^|.+@.+..+/).test(values.email) ? "" : "Email is not valid";
        temp.password = values.password.length >= 6 ? "" : "Password must be at least 6 characters";
       
        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            try {
                const url = config.APIACTIVEURL + config.REGISTER;
                const response = await axios.post(url, {
                    name: values.fullName,
                    email: values.email,
                    phone: values.phone,
                    address: values.address,
                    password: values.password,
                    roleName: 'CUSTOMER'
                  
                });

                if (response.data.success) {
                    alert("Registration Successful!");
                    navigate('/'); // Redirect to home or login
                }
            } catch (error) {
                alert(error.response?.data?.message || "Registration failed");
            } finally {
                setBtnLoading(false);
            }
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100" style={{ paddingTop: '100px', paddingBottom: '50px' }}>
            <div className="card border-0 shadow-lg p-4 w-100" style={{ maxWidth: '600px', borderRadius: '2rem' }}>
                <div className="text-center mb-4">
                    <h2 className="fw-bold">Customer Registration</h2>
                    <p className="text-muted">Create your account to book appointments</p>
                </div>

                <form className="row g-3" onSubmit={handleSubmit}>
                    <div className="col-12">
                        <label className="form-label fw-bold">Full Name</label>
                        <input 
                            type="text" 
                            name="fullName" 
                            value={values.fullName} 
                            onChange={handleInput} 
                            className={`form-control py-3 rounded-3 ${errors.fullName ? 'is-invalid' : ''}`} 
                            placeholder="Enter your full name" 
                        />
                        {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-bold">Email Address</label>
                        <input 
                            type="email" 
                            name="email" 
                            value={values.email} 
                            onChange={handleInput} 
                            className={`form-control py-3 rounded-3 ${errors.email ? 'is-invalid' : ''}`} 
                            placeholder="email@example.com" 
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-bold">Phone Number</label>
                        <input 
                            type="tel" 
                            name="phone" 
                            value={values.phone} 
                            onChange={handleInput} 
                            className="form-control py-3 rounded-3" 
                            placeholder="Phone Number" 
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-bold">Password</label>
                        <input 
                            type="password" 
                            name="password" 
                            value={values.password} 
                            onChange={handleInput} 
                            className={`form-control py-3 rounded-3 ${errors.password ? 'is-invalid' : ''}`} 
                            placeholder="******" 
                        />
                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    </div>

                    <div className="col-12">
                        <label className="form-label fw-bold">Address</label>
                        <textarea 
                            name="address" 
                            value={values.address} 
                            onChange={handleInput} 
                            className="form-control rounded-3" 
                            rows="2" 
                            placeholder="Full Address"
                        ></textarea>
                    </div>

                    <div className="col-12">
                        <div className="form-check">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id="termsCheck" 
                                required 
                            />
                            <label className="form-check-label small" htmlFor="termsCheck">
                                I agree to the Terms & Conditions and Privacy Policy
                            </label>
                        </div>
                    </div>

                    <div className="col-12 text-center mt-4">
                        <button 
                            type="submit" 
                            disabled={btnLoading} 
                            className="btn py-3 px-5 text-white fw-bold rounded-3 w-100 shadow-sm" 
                            style={{ backgroundColor: '#136e68' }}
                        >
                            {btnLoading ? 'Processing...' : 'Register'}
                        </button>
                        <p className="mt-3">
                            Already have an account?{' '}
                            <Link to="/" className="fw-bold text-decoration-none" style={{ color: '#136e68' }}>
                                Login
                            </Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RegisterCustomer;